<template>
    <!-- 蔬菜报价栏 -->
    <div class="bottom-left phone-content">
        <!-- 导航 -->
        <div class="btn-container">
            <div class="btn-div">
                <a href="JavaScript:;" class="btn-a" @click="btnBjClick(0)">蔬菜</a>
            </div>
            <div class="btn-div">
                <a href="JavaScript:;" class="btn-a" @click="btnBjClick(1)">水果</a>
            </div>
            <div class="btn-div">
                <a href="JavaScript:;" class="btn-a" @click="btnBjClick(2)">肉类</a>
            </div>
            <div class="btn-div">
                <a href="JavaScript:;" class="btn-a" @click="btnBjClick(3)">水产</a>
            </div>
            <div class="btn-div">
                <a @click="onRouter('/ncpxx?subNavNumber=1')">查看更多</a>
            </div>
        </div>
        <!-- 表头 -->
        <ul class="table-th">
            <li>品种</li>
            <li>最高价格</li>
            <li>最低价格</li>
            <li>计量单位</li>
            <li>更新日期</li>
        </ul>
        <!-- 蔬菜 -->
        <div id="parent" class="list-container offer parent" @mouseenter="onClose()" @mouseleave="onOpen()">
            <table id="child1" class="table child1">
                <tr v-for="_ in scList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
            <table v-if="scList.length > 5" id="child2" class="table child2">
                <tr v-for="_ in scList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
        </div>
        <!-- 水果 -->
        <div id="parent" class="no-display offer parent" @mouseenter="onClose()" @mouseleave="onOpen()">
            <table id="child1" class="table child1">
                <tr v-for="_ in sgList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
            <table v-if="sgList.length > 5" id="child2" class="table child2">
                <tr v-for="_ in sgList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
        </div>
        <!-- 肉类 -->
        <div id="parent" class="no-display offer parent" @mouseenter="onClose()" @mouseleave="onOpen()">
            <table id="child1" class="table child1">
                <tr v-for="_ in rlList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
            <table v-if="rlList.length > 5" id="child2" class="table child2">
                <tr v-for="_ in rlList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
        </div>
        <!-- 水产 -->
        <div id="parent" class="no-display offer parent" @mouseenter="onClose()" @mouseleave="onOpen()">
            <table id="child1" class="table child1">
                <tr v-for="_ in apList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
            <table v-if="apList.length > 5" id="child2" class="table child2">
                <tr v-for="_ in apList" :key="_">
                    <td>{{_.title}}</td>
                    <td>¥{{_.highPrice}}</td>
                    <td>¥{{_.lowPrice}}</td>
                    <td>{{_.measureUnit}}</td>
                    <td>{{_.createTime.slice(0,10)}}</td>
                </tr>
            </table>
        </div>
    </div>
</template>

<script>
import { getProductsList } from "@/api/index.js";
import router from '@/router';
export default {
    data() {
        return {
            scList: [],
            sgList: [],
            rlList: [],
            apList: [],
        };
    },
    created(){
        // 农产品信息-蔬菜
        getProductsList({quotationType: 'VEGATABLES', current: 1, size: 99999}).then((res)=>{
            this.scList = res.data.records || []
        })
        // 农产品信息-水果
        getProductsList({quotationType: 'FRUIT', current: 1, size: 99999}).then((res)=>{
            this.sgList = res.data.records || []
        })
        // 农产品信息-肉类
        getProductsList({quotationType: 'MEAT', current: 1, size: 99999}).then((res)=>{
            this.rlList = res.data.records || []
        })
        // 农产品信息-水产
        getProductsList({quotationType: 'AQUATIC', current: 1, size: 99999}).then((res)=>{
            this.apList = res.data.records || []
        })
        setTimeout(()=>{
            this.onOpen()
        },500)
    },
    methods: {
        onRouter(url){
            router.push(url)
            setTimeout(()=>{
                window.location.reload()
            },100)
        },
        // 蔬菜报价表
        btnBjClick(idx){
            let MoreContainer = document.getElementsByClassName('more-container');
            let BtnA = document.getElementsByClassName('btn-a');
            let Offer = document.getElementsByClassName('offer');
            for (let i=0; i<4; i++){
                if(i == idx){
                    BtnA[idx].style.borderLeft = '3px solid red';
                    BtnA[idx].style.color = 'red';
                    Offer[idx].className = 'list-container offer parent';
                    if (MoreContainer.length != 0) {
                        MoreContainer[idx].className = 'more-container';
                    }
                } else {
                    BtnA[i].style.borderLeft = 'none';
                    BtnA[i].style.color = '#fff';
                    Offer[i].className = 'no-display offer parent';
                    if (MoreContainer.length != 0) {
                        MoreContainer[i].className = 'no-display more-container';
                    }
                }
            }
        },
        onOpen(){
            let parent = document.getElementsByClassName('parent');
            let child1 = document.getElementsByClassName('child1');
            this.timeTable = setInterval(function () {
                for (let i=0; i<4; i++){
                    if(parent[i].scrollTop >= child1[i].scrollHeight) {
                        parent[i].scrollTop = 0;
                    } else {
                        parent[i].scrollTop++;
                    }
                }
            }, 50);
        },
        onClose(){
            // 清除定时器
            clearInterval(this.timeTable);
        },
    },
};
</script>
<style lang="less" scoped>
a{
    cursor: pointer;
}
</style>